export var PURE_MULTIPLE_CHOICE_EXERCISE = 'PureMultipleChoiceExercise';
export var EXPORTED_EXERCISES = [PURE_MULTIPLE_CHOICE_EXERCISE];